import { endpoints, endpointsPresentacionesArticlesDoc, endpointsPresentaciones, endpointsContactHospitals } from '../api/endpoints'
import { API } from './comunApi'

export const presentationsApi = {
    getPresentationById: async id => {
        return await API.get(
            endpointsPresentaciones.GET_PRESENTATION_BY_ID(id)
        )
    },
    newPresentation: async params => {
        return await API.post(
            endpointsPresentaciones.NEW_PRESENTATIONS,
            params
        )
    },
    deletePresentations: async id => {
        return await API.delete(
            endpointsPresentaciones.DELETE_PRESENTATIONS(id)
        )
    },
    
}

export const contactsPresentationsApi = {
    newContactsPresentations: async params => {
        return await API.post(
            endpointsContactHospitals.NEW_CONTACTS_PRESENTATIONS,
            params
        )
    }, 
    sendPresentationContact: async (id_ContactoPresentacion) => {
        return await API.post(
            endpointsContactHospitals.SEND_PRESENTATION_TO_CONTACT(id_ContactoPresentacion)
        )
    },
    goToAccessPresentationOfAContact: async (idPresentation, params) => {
        return await API.post(
            endpoints.ACCESS_TO_PRESENTATION_OF_A_CONTACT(idPresentation),
            params
        )
    }

}

export const presentationProductsApi = {
    //Devolver todos los documentos de una presentacion en concreto creada por un usuario
    getInfoProductsPresentationById: async id => {
        return await API.get(
            endpointsPresentacionesArticlesDoc.GET_INFO_PRESENTAION_ARTICLES_DOCUMENTS_BY_ID_PRESENTATION(id)
        )
    },
    getProductDocsPresentation: async ( idPresentation, idArticle )=> {
        return await API.get(
            endpointsPresentacionesArticlesDoc.GET_DOCS_ARTICLE_Of_PRESENTATION(idPresentation, idArticle)
        )
    },
    getPresentationDocs: async ( idPresentation )=> {
        return await API.get(
            endpointsPresentacionesArticlesDoc.GET_PRESENTATION_ALL_DOCS(idPresentation)
        )
    },
    addDocsProductsToPresentation: async params => {
        return await API.post(
            endpointsPresentacionesArticlesDoc.ADD_DOCS_PRODUCTS_TO_PRESENTATIONS,
            params
        )
    },
    updateDocProductsToPresentation: async (params, id_presentation, id_article) => {
        return await API.put(
            endpointsPresentacionesArticlesDoc.UPDATE_DOC_PRODUCTS_TO_PRESENTATIONS(id_presentation, id_article),
            params
        )
    },
            
    deleteDocProductsToPresentation: async (id_presentation, id_article, id_ArticuloDocumento ) => {
        return await API.delete(
            endpointsPresentacionesArticlesDoc.DELETE_DOC_PRODUCT_PRESENTATION(id_presentation, id_article, id_ArticuloDocumento)
        )
    },
    // Elimina el prodcuto de la presentación, eso conlleva eliminar todos sus documentos
    deletePresentationProduct: async (id_presentation, id_article) => {
        return await API.delete(
            endpointsPresentacionesArticlesDoc.DELETE_PRESENTATION_ARTICLES_DOCUEMNTS_BY_ID_ARTICLE(id_presentation, id_article)
        )
    },
}